export const STEP_NAME_PLACEHOLDER = 'Untitled step';
export const ADDING_STEP_TEXT = 'Adding step...';
